"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUtilsConfigSetup = void 0;
var ApiUtilsConfig_1 = require("./ApiUtilsConfig");
var ApiUtilsConfigSetup = /** @class */ (function () {
    function ApiUtilsConfigSetup() {
    }
    ApiUtilsConfigSetup.register = function (config) {
        if (!config.hasKey(ApiUtilsConfig_1.ApiUtilsConfig.apiKey)) {
            config.registerKey(ApiUtilsConfig_1.ApiUtilsConfig.apiKey);
        }
    };
    return ApiUtilsConfigSetup;
}());
exports.ApiUtilsConfigSetup = ApiUtilsConfigSetup;
//# sourceMappingURL=ApiUtilsConfigSetup.js.map